import React, { useLayoutEffect } from 'react';

import { isPayWebview as isPayWebviewFromAppInfo } from '~/utils/appInfo';

export const useIsPayWebview = () => {
  const [isPayWebview, setIsPayWebview] = React.useState<boolean | null>(null);

  useLayoutEffect(() => {
    setIsPayWebview(isPayWebviewFromAppInfo);
  }, []);

  return isPayWebview;
};
